// Axios HTTP client
import Axios from "axios";

// Utilities
import AxiosConfig from "src/utilities/AxiosConfig";

// Types
import I_BaseAPIResponse from "src/common_interfaces/I_BaseAPIResponse";
import {
  I_FetchPortalAPIGeneratedPDFRequest,
  I_FetchPortalAPIGeneratedPDFResponse,
} from "../I_FetchPortalAPIGeneratedPDF";

/**
 * getPortalAPIGeneratedPDF
 * ------------------------
 * Makes a POST request to the backend PDF Generator endpoint to produce a
 * base64-encoded PDF for a given event template and data payload.
 *
 * @param template - The template name to use (e.g. "samsaraIncident")
 * @param data - The payload object containing SafetyEvent and optional ApprovalHistory
 * @returns A promise that resolves to a standardized API response with PDF base64
 */
const getPortalAPIGeneratedPDF = async (
  { template, data }: I_FetchPortalAPIGeneratedPDFRequest
): Promise<I_BaseAPIResponse<I_FetchPortalAPIGeneratedPDFResponse>> => {
  const response = await Axios.post<I_BaseAPIResponse<I_FetchPortalAPIGeneratedPDFResponse>>(
    `${process.env.REACT_APP_API_URL}/api/pdfGenerator/generatePDF/${template}`,
    {
      SafetyEvent: data,
      // Allow undefined or missing ApprovalHistory safely
      //@ts-ignore - backend accepts this even if not explicitly typed
      ApprovalHistory: data.ApprovalHistory ?? [],
    },
    AxiosConfig.configValue("min")
  );

  return response.data;
};

export default getPortalAPIGeneratedPDF;
